import { gsap } from "gsap";
import { findAll } from "../utils/dom.js";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import animateFrom from "./animateFrom.js";


export default function animaAoScroll() {
	const start = "top bottom+=200px"

	findAll("[js-anima-timeline]").forEach(function (elem) {
		let tl = gsap.timeline({
			scrollTrigger: {
				scrub: 1,
				trigger: elem,
				start: "top 60%",
				end: 'bottom 10%',
			}
		})
		tl.from(elem, {
			ease: 'power2',
			scale: '.7',
			rotation: 90,
		})

	})

	findAll("[js-anima-timeline-scale]").forEach(function (elem) {
		let tl = gsap.timeline({
			scrollTrigger: {
				scrub: 1,
				trigger: elem,
				start: "top 90%",
				end: 'bottom 20%',
			}
		})
		tl.from(elem, {
			ease: 'power2',
			scale: '.3',
		})

	})

	findAll("[js-anima-timeline-apoio]").forEach(function (elem) {
		let tl = gsap.timeline({
			scrollTrigger: {
				scrub: true,
				trigger: elem,
				start: "top 50%",
				end: 'bottom 20%',
			}
		})
		tl.from(elem, {
			ease: 'power2',
			y: -240,
		})
	})



	findAll("[js-anima]")
		.forEach(function (elem) {

			ScrollTrigger.create({
				trigger: elem,
				once: true,
				start: start,
				refreshPriority: 10,
				//markers: true,
				onEnter: function () {
					animateFrom(elem)

				},
				// onEnterBack: function () {
				// 	animateFrom(elem, -1)
				// },
				// onLeave: function () {
				// 	hide(elem)
				// } // assure that the element is hidden when scrolled into view


			});
		});


}